import React from 'react';
import { assetPathFn } from '../../util';
import styles from './ProductFeatures.module.scss';

export const ProductFeatures: React.FC<{
  features: {
    title: string;
    description: string;
    imgName?: string;
  }[];
  descriptionMaxWidth?: string;
}> = ({ features, descriptionMaxWidth }) => {
  return (
    <div className={styles.productFeaturesWrapper}>
      <div className={styles.productFeatureDetailsWrapper}>
        {features.map((feature, i) => {
          return (
            <div key={i}>
              {feature.imgName && (
                <div className={styles.productFeatureImage}>
                  <img src={assetPathFn(feature.imgName)} alt={feature.title} />
                </div>
              )}
              <div className={styles.productFeatureDetailsText}>
                <div className={styles.productFeatureDetailsTitleText}>{feature.title}</div>
                <div className={styles.productFeatureDetailsSubText} style={descriptionMaxWidth ? { maxWidth: descriptionMaxWidth } : {}}>
                  {feature.description}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductFeatures;
